export function addDaysToIsoDate(iso: string, days: number): string {
  const [yearStr, monthStr, dayStr] = iso.split('-')
  const year = Number(yearStr)
  const month = Number(monthStr)
  const day = Number(dayStr)
  const date = new Date(year, month - 1, day)
  date.setDate(date.getDate() + days)
  const resultYear = date.getFullYear()
  const resultMonth = String(date.getMonth() + 1).padStart(2, '0')
  const resultDay = String(date.getDate()).padStart(2, '0')
  return `${resultYear}-${resultMonth}-${resultDay}`
}

export function monthDateBounds(reportMonth: string): { from: string; to: string } {
  const [yearStr, monthStr] = reportMonth.split('-')
  const year = Number(yearStr)
  const month = Number(monthStr)
  const lastDay = new Date(year, month, 0).getDate()
  return {
    from: `${reportMonth}-01`,
    to: `${reportMonth}-${String(lastDay).padStart(2, '0')}`,
  }
}

export function billingLedgerCandidateDateBounds(
  reportMonths: string[],
): { from: string; to: string } | null {
  if (reportMonths.length === 0) return null
  const sorted = [...reportMonths].sort()
  const firstMonth = sorted[0]
  const lastMonth = sorted[sorted.length - 1]
  if (!firstMonth || !lastMonth) return null
  const firstBounds = monthDateBounds(firstMonth)
  const lastBounds = monthDateBounds(lastMonth)
  return {
    from: firstBounds.from,
    to: addDaysToIsoDate(lastBounds.to, 30),
  }
}
